export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70267f6ad21364708926287c03001dc4d03b190e4b&name=pushAdClickData!'